//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ForgotPasswordForm from "~/themes/fiskarsMoominDefault/components/components/organisms/ForgotPasswordForm/ForgotPasswordForm.vue";
export default {
  name: "MoominForgotPasswordForm",
  components: {
      ForgotPasswordForm
  },
  props: {
    title: {
      type: String,
      default: 'Log in details'
    },
    email: {
      type: String,
      default: 'Email'
    },
    emailplaceholdertext: {
      type: String,
      default: 'Email'
    },
    emailvalidationmessage: {
      type: String,
      default: 'Email error'
    },
    emailformatvalidationmessage: {
      type: String,
      default: 'This is not a valid email'
    },
    successmessagetitle: {
      type: String,
      default: 'Success'
    },
    successmessagedescription: {
      type: Object,
      default: () => ({}),
    },
    formvalidationmessage: {
      type: String,
      default: 'Form submission error'
    },
    buttontext: {
      type: String,
      default: 'Submit'
    },
    link: {
      type: String,
      default: ''
    },
    success: {
      type: Object,
      default: () => ({})
    },
    error: {
      type: Object,
      default: () => ({})
    }
  },
}
